import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import "assets/vendor/bootstrap-rtl/bootstrap-rtl.scss";
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "assets/vendor/fullcalendar/dist/fullcalendar.min.css";
import "assets/vendor/sweetalert2/dist/sweetalert2.min.css";
import "assets/vendor/select2/dist/css/select2.min.css";
import "assets/vendor/quill/dist/quill.core.css";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-pro-react.scss?v1.1.0";

import config from "services/config";
import axios from "axios";
import decode from "jwt-decode";
import { createStore, combineReducers } from "redux";
import { Provider } from "react-redux";

import AdminLayout from "layouts/Admin";
import ApLayout from "layouts/Ap";
import TaxLayout from "layouts/Tax";
import AuthLayout from "layouts/Auth";
import Vendor from "layouts/Vendor";
// import HospitalVendor from "layouts/Hospital";
import Forwarder from "layouts/Forwarder";
import RegulationLayout from "layouts/Regulation";

import companyReducer from "views/Admin/Companies/Redux/companyReducer";
import userReducer from "views/Admin/User/Redux/userReducer";


const protectionRoute = ()=>{
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }
  try {
    var token_local = decode(token);
    var exp = decode(token_local.token);
    var currentTime = new Date().getTime() / 1000;
    if (exp.exp < currentTime) {
      axios
      .post(config.API_URL + "/auth/logout",{ user_id: token_local.user_id}, {
        headers: {
          "Content-Type": "application/json"
        },
      })
      localStorage.clear();
      window.location.reload(true);
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}

const routeVerification = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return false;
  }
  try {
    var token_local = decode(token);
    var exp = decode(token_local.token);
    var currentTime = new Date().getTime() / 1000;
    if (exp.exp < currentTime) {
      axios
      .post(config.API_URL + "/auth/logout",{ user_id: token_local.user_id}, {
        headers: {
          "Content-Type": "application/json"
        },
      })
      localStorage.clear();
      window.location.reload(true);
      return false;
    }
    return true 
  } catch (e) {
    return false;
  }
};
// const roleRoute = ()=>{
//   const token = localStorage.getItem("token");
//    var token_local = decode(token);
//    var id = token_local.role_id
//   try {
//     var path 
//     if(id === 6){
//         <Redirect to={{ pathname: "/vendor" }} />
//       } else if (id === 9 ){
//       <Redirect to={{ pathname: "/vendor" }} />
//     }
//     return path;
//   } catch (e) {
//     return 0;
//   }
// }
//authentication
const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      routeVerification() ? ( 
        <Redirect to={{ pathname: "/vendor" }} />
      ) : (
        <Component {...props} />
      )
    }
  />
);
//vendor
const VendorRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      protectionRoute() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/auth/login" }} />
      )
    }
  />
);
// const HospitalRoute = ({ component: Component, ...rest }) => (
//   <Route
//     {...rest}
//     render={(props) =>
//       protectionRoute() ? (
//         <Component {...props} />
//       ) : (
//         <Redirect to={{ pathname: "/auth/login" }} />
//       )
//     }
//   />
// );
//tax
const TaxRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      protectionRoute() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/auth/tax" }} />
      )
    }
  />
);
//ap
const ApRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
   protectionRoute() ? (
     <Component {...props} />
    ) : (
        <Redirect to={{ pathname: "/auth/ap" }} />
      )
    }
  />
);
//admin
const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
 protectionRoute() ? (
   <Component {...props} />
  ) : (
        <Redirect to={{ pathname: "/auth/do" }} />
      )
    }
  />
);
//forwarder
const ForwarderRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
    protectionRoute() ? (
      <Component {...props} />
    ) : (
        <Redirect to={{ pathname: "/auth/forwarder" }} />
      )
    }
  />
);
//regulation public
const Regulation = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
        <Component {...props} />
    }
  />
);

const rootReducer = combineReducers({
  company: companyReducer,
  user: userReducer,
});
const storeRedux = createStore(rootReducer);
ReactDOM.render(
  <Provider store={storeRedux}>
    <BrowserRouter>
      <Switch>
        <AuthRoute path="/auth" component={AuthLayout} />
        <VendorRoute path="/vendor" name="vendor" component={Vendor} />
        {/* <HospitalRoute path="/hospital" component={HospitalVendor} /> */}
        <AdminRoute path="/admin" component={AdminLayout} />
        <TaxRoute path="/tax" component={TaxLayout} />
        <ApRoute path="/ap" component={ApLayout} />
        <Regulation path ="/regulation" component={RegulationLayout} />
        <ForwarderRoute path="/forwarder" component={Forwarder} />
        {/* <Redirect path="/" to="/auth/login" /> */}
         <Redirect path="/" to="/vendor" />
      </Switch>
    </BrowserRouter>
  </Provider>
  ,
  document.getElementById("root")
);
